import { render } from "./AppMain.vue?vue&type=template&id=56793fe7&scoped=true&ts=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=56793fe7&lang=scss&scoped=true"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56793fe7"]])

export default __exports__